import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';

export default styled(TableRow)(({ theme }) => ({
    cursor: 'pointer',
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.grey[200],
    },
}));
